import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../contexts/AuthContext.jsx";
import { renderImage } from "../../../../utils/helper.jsx";
import { toast } from "react-toastify";
import { location, permission } from "../../../../api";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../components/card/card.jsx";
import NormalInput from "../../../../components/form/HorizontalNormalInput/index.jsx";
import { Form } from "react-bootstrap";
import NormalTextArea from "../../../../components/form/HorizontalNormalTextarea/index.jsx";
function ModalChangeRole({ open, onClose, onSubmit, row }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  async function getLocations() {
    try {
      const res = await location.list();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;

        setLocations(data);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  async function getPermissions() {
    try {
      const res = await permission.list();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;

        const group = Object.groupBy(data, ({ action }) => action);
        setPermissions(group);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  useEffect(() => {
    getLocations();
    getPermissions();
  }, []);

  useEffect(() => {
    if (open) {
      if (row) {
        setName(row.name);
        setDescription(row.description);
        setSelectedPermissions(
          row.permissions.map((p) => ({ id: p.permission_id }))
        );
      }
    }
  }, [open]);

  async function handleSubmit() {
    //validation
    let errors = [];
    if (!name) {
      errors.push("Enter Role Name");
    }
    if (errors.length > 0) {
      toast.error(errors.join("\n"));
      return;
    }
    onSubmit({
      name,
      description,
      permissions: selectedPermissions,
    });
    if (!row) {
      clearFields();
    }
  }

  function clearFields() {
    setName("");
    setDescription("");
    setSelectedPermissions([]);
  }
  async function handleClose() {
    clearFields();
    onClose();
  }

  const handleSelectLocation = (id) => {
    if (selectedLocations.includes(id)) {
      setSelectedLocations((values) => values.filter((v) => v !== id));
    } else {
      setSelectedLocations((values) => [...values, id]);
    }
  };

  const isSelectedLocation = (id) => {
    return selectedLocations.includes(id);
  };

  const selectPermission = (p) => {
    if (selectedPermissions.find((sp) => sp.id == p.id)) {
      const selected = [...selectedPermissions].filter((sp) => sp.id !== p.id);
      setSelectedPermissions(selected);
    } else {
      setSelectedPermissions((prev) => [...prev, p]);
    }
  };

  const isPermissionSelected = (p) => {
    if (selectedPermissions.find((sp) => sp.id == p.id)) {
      return true;
    } else {
      return false;
    }
  };

  const renderLocations = (locations) => {
    return (
      <>
        {locations.map((location, index) => {
          return (
            <div key={index}>
              <div
                className="form-check"
                onClick={() => handleSelectLocation(location.id)}
              >
                <input
                  className="form-check-input"
                  checked={isSelectedLocation(location.id)}
                  type="checkbox"
                  id={`${location.id}`}
                />
                <label className="form-check-label" htmlFor={location.id}>
                  {location.location_name}
                </label>
              </div>
              {location.sublocations && location.sublocations.length > 0 && (
                <div style={{ marginLeft: "20px" }}>
                  {renderLocations(location.sublocations)}
                </div>
              )}
            </div>
          );
        })}
      </>
    );
  };

  return (
    <ConfirmationDlg
      open={open}
      size={"lg"}
      btnCancelText="Cancel"
      btnSubmitText={"Submit"}
      onSubmit={handleSubmit}
      onClose={handleClose}
    >
      <div className="my-2">
        <NormalInput
          onchange={(e) => {
            setName(e.target.value);
          }}
          required
          type="text"
          value={name}
          label={"Name"}
        />
        <NormalTextArea
          onchange={(e) => {
            setDescription(e.target.value);
          }}
          type="text"
          value={description}
          label={"Description"}
        />

        <Card>
          <CardHeader>Permissions</CardHeader>
          <CardBody>
            <div className="d-flex row">
              {Object.entries(permissions).map(([key, value], index) => {
                return (
                  <div key={key} className="col-md-6">
                    <div
                      style={{
                        fontWeight: "bold",
                        textTransform: "capitalize",
                        marginBottom: 5,
                      }}
                    >
                      {" "}
                      {key}
                    </div>

                    {value.map((v) => {
                      return (
                        <Form.Check
                          key={v.id}
                          style={{ textTransform: "capitalize" }}
                          onChange={() => selectPermission(v)}
                          type={"checkbox"}
                          label={v.target}
                          checked={isPermissionSelected(v)}
                        />
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </CardBody>
        </Card>
      </div>
    </ConfirmationDlg>
  );
}

export default ModalChangeRole;
